<template lang="pug">
.crowd-container
  .crowd-content.form
    v-form(
      v-model="newCrowd",
      :before-submit="preventSubmit",
      ref="crowdForm")
      .item
        .label 人群名称：
        .control
          v-input(name="name",
            :class="{'error': !isNameValid}",
            :disabled="isDisabled",
            @focus="isNameValid = true",
            v-model="newCrowd.name",
            :rules="rules.name",
            placeholder="请输入1-20字符名称")
      .item
        .label 人群定义：
        .control-tool
          timeSpan(@change="onTimespanChange",
            :noCommitState="noCommitState",
            filters="7a")
          p.crowd-data 
            span 用户数约：
            span.crowd-num(v-if="!crowdDataLoading") {{crowdNum}}
            span.loading(v-else) 
              img(src="https://p4.ssl.qhimg.com/t019c427ceb6ab4efec.gif")
            span 用户占比：
            span.crowd-percent(v-if="!crowdDataLoading") {{crowdPercent}}
            span.loading(v-else) 
              img(src="https://p4.ssl.qhimg.com/t019c427ceb6ab4efec.gif")

        .control-wrap(
          :class="{'no-scroll': noscroll}",
          @mousewheel="onMousewheel($event)")

          p.opt-add(v-if="newCrowd.attr_rule.length == 0 && !isDisabled",
            @click="addNewAttr")
            i.fa.fa-plus-circle.fa-mgr
            | 添加人群属性
          p.attr-list(v-else-if="newCrowd.attr_rule.length > 0")
            | 人群属性
            p.attr-item(v-for="attrItem,index in newCrowd.attr_rule")
              Cascader(placeholder="请选择条件",
                :menu="attrDims",
                v-model="attrItem.d",
                @input="changeDim(attrItem)"
                size="big",
                :valid="attrItem.d_valid",
                :disabled="isDisabled",
                showkey='title'
              )
              v-select(
                v-model="attrItem.d_r",
                @input="attrDvChange(attrItem)",
                :options="drRelationships",
                :disabled="isDisabled"
                )
              MutilSelect(v-model="attrItem.d_v",
                  @input="setCurrentItem(attrItem)",
                  @change="dvChange",
                  :valid="attrItem.v_valid",
                  :placeholder="getPlaceholder(attrDims, attrItem)",
                  api="/api/crowd/getDimValue",
                  :isSearched="checkSearchable(attrDims, attrItem.d)",
                  :dim="getAttrActionDim(attrDims, attrItem.d)",
                  :maxlength="maxRuleNum",
                  :disabled="isDisabled"
                )
              i.fa.fa-trash-o.fa-lg.fa-mgr(title="删除",
                v-show="!isDisabled",
                @click="removeAttrItem(index)")
              i.fa.fa-plus-circle.fa-lg(
                v-show="!isDisabled && isMaxLength(index, newCrowd.attr_rule)",
                title="添加",
                @click="addNewAttr")
            p.attr-item(v-show="newCrowd.attr_rule.length > 1")
              v-radio-group(
                  v-model="newCrowd.attr_calc",
                  @input="getEstimate()",
                  :disabled="isDisabled",
                  :options="calcRelations"
                )

          p.opt-add(v-if="!isDisabled && newCrowd.action_rule.length == 0",
            @click="addNewAction")
            i.fa.fa-plus-circle.fa-mgr
            | 添加用户行为
          p.action-list(v-else-if="newCrowd.action_rule.length > 0")
            | 用户行为
            p.action-item(v-for="actionItem,index in newCrowd.action_rule")
              Cascader(placeholder="请选择条件",
                :menu="actionDims",
                v-model="actionItem.d",
                :valid="actionItem.d_valid",
                size="small",
                :disabled="isDisabled",
                @input="changeDim(actionItem)",
                showkey='title'
              )
              MutilSelect(v-model="actionItem.d_v",
                  v-show="checkDvShow(actionItem.d)",
                  @input="setCurrentItem(actionItem)",
                  @change="dvChange",
                  api="/api/crowd/getDimValue",
                  :valid="actionItem.v_valid",
                  :placeholder="getPlaceholder(actionDims, actionItem)",
                  :isSearched="checkSearchable(actionDims, actionItem.d)",
                  :dim="getAttrActionDim(actionDims, actionItem.d)",
                  :maxlength="maxRuleNum",
                  :inputPattern="urlPattern(actionItem)",
                  :disabled="isDisabled"
                )
              
              v-select(
                :disabled="isDisabled",
                @input="mvChange(actionItem)",
                v-model="actionItem.m_r",
                :options="mrRelationships"
                )
              span.atime(v-if="actionItem.d === 'atime'")
                input.size-mini(v-model="actionItem.minutes",
                  autocomplete="off",
                  type="number",
                  @input="calcTime(actionItem)")
                | 分
                input.size-mini(v-model="actionItem.seconds",
                  autocomplete="off",
                  type="number",
                  :class="{'error': actionItem.s_valid}",
                  @input="calcTime(actionItem)")
                | 秒
              span(v-if="actionItem.d !== 'atime'")
                input.size-small(name="name",
                  autocomplete="off",
                  min="0",
                  type="number",
                  :class="{'error': actionItem.m_valid}",
                  @input="numberChange(actionItem)",
                  :disabled="isDisabled",
                  v-model="actionItem.m_v",
                  :placeholder="mvPlaceholder(actionItem)")
              i.fa.fa-trash-o.fa-lg.fa-mgr(title="删除",
                v-show="!isDisabled",
                @click="removeActionItem(index)")
              i.fa.fa-plus-circle.fa-lg(
                v-show="!isDisabled && isMaxLength(index, newCrowd.action_rule)",
                title="添加",
                @click="addNewAction")
            p.attr-item(v-show="newCrowd.action_rule.length > 1")
              v-radio-group(
                  v-model="newCrowd.action_calc",
                  @input="getEstimate()",
                  :options="calcRelations"
                )
  .crowd-footer
    slot(name="btnwraper", :crowd="newCrowd")

</template>
<script>
/* global _ */
import Store from '../store/store.js'
export default {
  store: Store,
  props: {
    type: {
      type: String,
      default: 'add'
    },
    noscroll: Boolean,
    crowd: {
      type: Object,
      default () {
        return {
          name: '',
          action_rule: [],
          attr_rule: [],
          attr_calc: 1,
          action_calc: 1
        }
      }
    }
  },
  data () {
    return {
      maxRuleNum: 10,
      isNameValid: true,
      noCommitState: true,
      start: '',
      end: '',
      total: 0,
      currentItem: {},
      newCrowd: {},
      crowdDataLoading: false,
      crowdNum: '--',
      crowdPercent: '--',
      crowdAttribute: '',
      selectedAction: 0,
      selectedAttribute: 0,
      attrDims: [],
      actionDims: [],
      notFirstTimeChange: false,
      calcRelations: [
        {
          value: 1,
          title: '和'
        }, {
          value: 2,
          title: '或'
        }
      ],
      drRelationships: [
        {
          value: 1,
          label: '是'
        }, {
          value: 2,
          label: '不是'
        }

      ],
      mrRelationships: [
        {
          value: 1,
          label: '>='
        }, {
          value: 2,
          label: '>'
        }, {
          value: 3,
          label: '='
        }, {
          value: 4,
          label: '<='
        }, {
          value: 5,
          label: '<'
        }
      ],
      rules: {
        name: {
          required: true,
          maxlength: 20,
          msg: {
            required: ' ',
            maxlength: ' '
          }
        },
        d: {
          required: true
        }
      }
    }
  },
  watch: {
    startValidCrowdForm (newVal, oldVal) {
      if (newVal) {
        this.validate()
      }
    },
    crowd () {
      this.$nextTick(() => {
        this.resetCrowd()
      })
    },
    type () {
      this.$nextTick(() => {
        this.resetCrowd()
        if (this.type !== 'add') {
          this.getEstimate()
        }
      })
    }
  },
  created () {
    this.resetCrowd()
    this.getDims()
  },
  computed: {
    startValidCrowdForm () {
      return this.$store.state.startValidCrowdForm
    },
    isDisabled () {
      return this.type === 'show'
    }
  },
  methods: {
    onMousewheel (e) {
      const elem = e.currentTarget
      const scrollTop = elem.scrollTop
      const dir = e.deltaY ? (e.deltaY < 0 ? 'up' : 'down') : void 0

      if (dir === 'up' && scrollTop <= 0) {
        return e.preventDefault()
      }

      if (dir === 'down' && (elem.clientHeight + scrollTop) === elem.scrollHeight) {
        return e.preventDefault()
      }
    },
    attrValidEs (item) {
      return item.d !== '' && item.d_v !== ''
    },
    actionValidEs (item, withoutMV) {
      const valid = item.d !== ''
      const dvValid = valid && this.checkDvShow(item.d) ? item.d_v !== '' : valid
      return withoutMV ? dvValid : dvValid && item.m_v !== ''
    },
    numberChange (item) {
      const valueValid = (this.actionValidEs(item) && !this.numberChecked(item))
      const novalueValid = (this.actionValidEs(item, true) && item.m_v === '')
      if (valueValid || novalueValid) {
        this.getEstimate()
      }
    },
    numberChecked (item) {
      const isValid = (item.d === 'jrate' && /^\d+.\d{0,3}$/.test(item.m_v))
        || /^\d+$/.test(item.m_v)
      this.$set(item, 'm_valid', !isValid)
      return !isValid
    },
    mvPlaceholder (item) {
      return item.d === 'jrate' ? '最多三位小数' : '请输入整数'
    },
    checkDvShow (d) {
      if (this.getAttrActionDim(this.actionDims, d).dim_group === '指标') {
        return false
      }
      return true
    },
    urlPattern (item) {
      if (item.d === 'url') {
        return '^https?:\/\/[a-zA-Z0-9][a-zA-Z0-9-]*\.[a-zA-Z0-9]+[^\\s]*\\s*$'
      }
      return ''
    },
    preventSubmit (e) {
      return false
    },
    calcTime (item) {
      this.$set(item, 'm_v', item.minutes * 60 + item.seconds)
      this.actionValidEs(item) && this.getEstimate()
      item.m_v === '' && this.actionValidEs(item, true) && this.getEstimate()
    },
    setCurrentItem (item) {
      this.currentItem = item
    },
    checkSearchable (list, dim) {
      if (!dim) return true
      const currentDim = this.getAttrActionDim(list, dim)
      return _.has(currentDim, 'is_only_select') && !currentDim.is_only_select
    },
    getPlaceholder (dimList, item) {
      return item.d === 'url' ? '请输入URL如：http://aaa.com, 可通配'
        : !this.checkSearchable(dimList, item.d) ? '请选择内容，最多10条'
          : '请选择/输入（回车保存）内容，最多10条'
    },
    checkRuleValid () {
      const rules = ['attr_rule', 'action_rule']
      let isValid = false
      _.map(rules, key => {
        _.map(this.newCrowd[key], item => {
          const isActionRuleDvShow = key === 'action_rule' && !this.checkDvShow(item.d)
          if (item.d === '') {
            isValid = true
            this.$set(item, 'd_valid', true)
          }
          if (item.d_v === '' && !isActionRuleDvShow) {
            isValid = true
            this.$set(item, 'v_valid', true)
          }
          if (_.has(item, 'm_v') && (this.numberChecked(item))) {
            isValid = true
            if (item.d === 'atime') {
              this.$set(item, 'm_v', item.minutes * 60 + item.seconds)
              this.$set(item, 's_valid', true)
            }
          }
          return item
        })
      })
      return isValid
    },
    validate () {
      this.$store.dispatch('SET_START_CROWDVALID', false)
      const formValid = this.$refs.crowdForm.isValid()
      const hasRules = this.newCrowd.attr_rule.length + this.newCrowd.action_rule.length > 0
      if (!hasRules) {
        this.$Modal.warn('请进行人群定义!')
        return
      }
      if (!this.checkRuleValid() && formValid) {
        this.$emit('validate', this.newCrowd)
      }
    },
    changeDim (item) {
      this.$nextTick(() => {
        this.$set(item, 'd_r', 1)
        if (_.has(item, 'm_v')) {
          // action
          const reset = () => {
            this.$set(item, 'm_r', 1)
            this.$set(item, 'd_v', '')
            this.$set(item, 'm_v', '')
          }
          if (this.actionValidEs(item)) {
            reset()
            this.getEstimate()
          } else {
            reset()
          }
        } else {
          // attr
          if (this.attrValidEs(item)) {
            this.$set(item, 'd_v', '')
            this.getEstimate()
          } else {
            this.$set(item, 'd_v', '')
          }
        }
      })
    },
    resetCrowd () {
      this.newCrowd = _.assign({}, {
        name: '',
        action_rule: [],
        attr_rule: [],
        attr_calc: 1,
        action_calc: 1
      }, this.crowd)
    },
    getAttrActionDim (list, dim) {
      let currentDim = {}
      _.map(list, item => {
        const filterDim = _.filter(item.childrenOptions, {'dim': dim})
        if (filterDim.length > 0) {
          currentDim = filterDim[0]
        }
      })
      return currentDim
    },
    dimFormate (list) {
      const groupData = _.groupBy(list, 'dim_group')
      const groupKeys = _.keys(groupData)
      const result = []
      _.forEach(groupKeys, (key, index) => {
        result.push({
          title: key,
          childrenOptions: _.map(groupData[key], item => {
            item.parent = key
            item.title = item.dim_desc
            item.seleced = false
            return item
          })
        })
      })
      return result
    },
    getDims () {
      const dimPromise = this.$http.get('/api/crowd/getDim', {
        params: {
          domainId: this.$store.state.domainId
        }
      })
      this.$store.dispatch('VUE_HTTP', [dimPromise])
        .then(res => {
          if (!res.errno) {
            this.attrDims = this.dimFormate(res.attr)
            this.actionDims = this.dimFormate(res.action)
          }
        })
    },
    isMaxLength (index, arr) {
      const maxLength = 5
      return arr.length < maxLength && index === (arr.length - 1)
    },
    addNewAction () {
      this.newCrowd.action_rule.push({
        d: '',
        d_r: 1,
        d_v: '',
        m_r: 1,
        m_v: '',
        seconds: 0,
        minutes: 0
      })
      this.$emit('updateItem', this.newCrowd)
    },
    removeActionItem (index) {
      this.newCrowd.action_rule.splice(index, 1)
      this.getEstimate()
      this.$emit('updateItem', this.newCrowd)
    },
    addNewAttr () {
      this.newCrowd.attr_rule.push({
        d: '',
        d_r: 1,
        d_v: ''
      })
      this.$emit('updateItem', this.newCrowd)
    },
    removeAttrItem (index) {
      this.newCrowd.attr_rule.splice(index, 1)
      this.getEstimate()
      this.$emit('updateItem', this.newCrowd)
    },
    onTimespanChange ({ start, end }) {
      this.start = start
      this.end = end
      this.getEstimate(this.notFirstTimeChange)
      this.notFirstTimeChange = true
    },
    mvChange (item) {
      const reset = () => {
        this.$set(item, 'm_v', '')
        this.$set(item, 'minutes', 0)
        this.$set(item, 'seconds', 0)
      }
      if (this.actionValidEs(item)) {
        this.getEstimate()
        reset()
      } else {
        reset()
      }
    },
    attrDvChange (item) {
      if (this.attrValidEs(item)) {
        this.$set(item, 'd_v', '')
        this.getEstimate()
      } else {
        this.$set(item, 'd_v', '')
      }
    },
    dvChange (tags) {
      this.$set(this.currentItem, 'd_id', _.map(tags, item => item.value).filter(item => item !== '').join(','))
      if (_.has(this.currentItem, 'm_v')) {
        if (this.actionValidEs(this.currentItem)) {
          this.$set(this.currentItem, 'm_v', '')
          this.getEstimate()
        } else {
          this.$set(this.currentItem, 'm_v', '')
        }
      } else {
        this.currentItem.d !== '' && this.getEstimate()
      }
    },
    notHasEstimateRule (list) {
      return list.length === 0 || _.filter(list, item => {
        if (_.has(item, 'm_v')) {
          const dvNotValid = item.d && this.checkDvShow(item.d) && item.d_v === ''
          return item.d === '' || dvNotValid || item.m_v === ''
        } else {
          return item.d === '' || item.d_v === ''
        }
      }).length === list.length
    },
    getEstimate (isCalc) {
      this.crowdDataLoading = true
      // 需要校验当前rule规则后判断是否需要进行预估数据
      const isAttrEstimate = this.notHasEstimateRule(this.newCrowd.attr_rule)
      const isActionEstimate = this.notHasEstimateRule(this.newCrowd.action_rule)
      if (isAttrEstimate && isActionEstimate) {
        this.crowdNum = '--'
        this.crowdPercent = '--'
        this.total = 'calc'
        this.crowdDataLoading = false
        return
      }
      const params = {
        domainId: this.$store.state.domainId,
        attr_calc: this.newCrowd.attr_calc,
        attr_rule: JSON.stringify(this.newCrowd.attr_rule),
        action_rule: JSON.stringify(this.newCrowd.action_rule),
        action_calc: this.newCrowd.action_calc,
        start: this.start,
        end: this.end,
        total: isCalc ? this.total : 'calc'
      }
      const estimatePromise = this.$http.post('/api/crowd/estimate', params, {emulateJSON: true})
      this.$store.dispatch('VUE_HTTP', [estimatePromise])
        .then(res => {
          this.crowdDataLoading = false
          if (!res.errno) {
            this.$nextTick(() => {
              this.crowdNum = res.crowd_num
              this.total = res.total
              this.crowdPercent = res.prop
            })
          } else {
            this.total = 'calc'
            this.crowdNum = '--'
            this.crowdPercent = '--'
          }
        })
    }
  },
  destroyed () {
    this.crowdNum = '--'
    this.crowdPercent = '--'
    this.total = 'calc'
  }
}
</script>
<style scoped>
.crowd-content {
  padding: 0 20px 0 5px;
}

.crowd-data {
  margin: 0;
  display: inline-block;
  margin-left: 20px;
}
.crowd-container .control {
  line-height: 2;
}

.crowd-container .control .q-timespan {
  margin: 0;
}
.crowd-num,
.crowd-percent {
  color: #73ace6;
  margin-right: 20px;
  font-weight: bold;
}
.control-wrap {
  background: #f5f8fb;
  width: 695px;
  max-height: 340px;
  min-height: 156px;
  margin-left: 80px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ced3d9;
    border-radius: 10px;
    border-radius: 30px;
  }
  &::-webkit-scrollbar-track {
    background: #eaeced;
  }
}
.control-tool {
    background: #f5f8fb;
    width: 695px;
    padding-left: 15px;
    margin-bottom: 1px;
    margin-left: 80px;
    .q-timespan {
        margin: 10px 0;
    }
}
.fa-mgr {
  margin-right: 5px;
}
.opt-add,
.attr-list,
.action-list {
  color: #73ace6;
  text-decoration: underline;
  line-height: 1;
  padding: 15px;
  margin-bottom: 25px;
}
.opt-add {
  width: 120px;
  cursor: pointer;
}
.attr-list,
.action-list {
  margin: 0;
  color: #666;
  text-decoration: none;
}
.attr-item,
.action-item {
  margin: 0 10px 10px;
  .fa {
    color: #a1b1be;
  }
  input {
    height: 28px;
    border-color: #e9e9e9;
  }
  .error {
    border-color: #E5675C;
  }
  .v-select {
    width: 60px;
  }
}
.atime {
  margin-right: 10px;
  .size-small {
    width: 120px;
  }
  .size-mini {
    width: 60px;
  }
}
.no-scroll {
  max-height: 100%;
}
.loading {
  display: inline-block;
  vertical-align: middle;
  margin-right: 20px;
  img {
    width: 20px;
    height: 20px;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// crowdTemplate.vue?48818f0c